import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { Th, Thead, Tr } from 'react-super-responsive-table';

import { getPlcSafetyZoneDependencies, deletePlcSafetyZoneDependency } from '../../store/actions';

class PlcSafetyZoneDependencyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      showConfirm: false,
      zoneDependencyToDelete: null,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingDeletePlcSafetyZoneDependency === false &&
      prevProps.loadingDeletePlcSafetyZoneDependency === true
    ) {
      this.props.getPlcSafetyZoneDependencies(this.state.user);
      if (this.props.deletePlcSafetyZoneDependencyError) {
        this.setState({
          popup: true,
          pop_msg: this.props.deletePlcSafetyZoneDependencyError.message || 'Error al eliminar la dependencia',
          alertType: 'error',
        });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  confirmDelete(zoneDependency) {
    this.setState({ showConfirm: true, zoneDependencyToDelete: zoneDependency });
  }

  doDelete() {
    const { user, zoneDependencyToDelete } = this.state;
    this.props.deletePlcSafetyZoneDependency({ id: zoneDependencyToDelete.id, token: user.token });
    this.setState({ showConfirm: false });
  }

  render() {
    const { zoneDependencyList } = this.props;
    return (
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{this.props.t('Dependencias entre zonas')}</CardTitle>
              <div className="table-responsive">
                <table className="table table-centered table-nowrap mb-0">
                  <Thead>
                    <Tr>
                      <Th>{this.props.t('Zona dependiente')}</Th>
                      <Th>{this.props.t('Depende de')}</Th>
                      <Th>{this.props.t('Actions')}</Th>
                    </Tr>
                  </Thead>
                  <tbody>
                    {zoneDependencyList.map((dep) => (
                      <tr key={dep.id}>
                        <td>
                          <span>{dep.zone_name}</span>
                        </td>
                        <td>
                          <span>{dep.depends_on_zone_name}</span>
                        </td>
                        <td>
                          <button
                            className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                            title="Eliminar"
                            onClick={() => this.confirmDelete(dep)}
                          >
                            <i className="far fa-trash-alt font-size-14 align-middle"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title="¿Estás seguro?"
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doDelete()}
            onCancel={() => this.setState({ showConfirm: false })}
          >
            {this.props.t('Se eliminará esta dependencia entre zonas')}
          </SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          ></SweetAlert>
        ) : null}
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const { loadingDeletePlcSafetyZoneDependency, deletePlcSafetyZoneDependencyError } =
    state.deletePlcSafetyZoneDependency;
  return { loadingDeletePlcSafetyZoneDependency, deletePlcSafetyZoneDependencyError };
};

export default withRouter(
  connect(mapStateToProps, { getPlcSafetyZoneDependencies, deletePlcSafetyZoneDependency })(
    withNamespaces()(PlcSafetyZoneDependencyList),
  ),
);
